import { Card, Avatar } from "antd";
import { MailOutlined } from "@ant-design/icons";
import { formatDateTime } from "../../../../../utils/functions";
import { getInitials } from "../../../../../utils/helper";

const EnhancedEmailLogCardView = ({
    record,
    onCardClick,
}) => {
    const initials = getInitials(record.userEmail);

    return (
        <Card
            hoverable
            className="h-full relative"
            onClick={() => onCardClick && onCardClick(record)}
        >
            <div className="space-y-3 sm:space-y-4">
                {/* Header */}
                <div className="flex items-start justify-between">
                    <div className="flex items-center space-x-2 sm:space-x-3 overflow-hidden">
                        <Avatar
                            size={40}
                            className="flex-shrink-0 font-semibold text-base sm:text-lg !bg-primary sm:w-12 sm:h-12"
                        >
                            {initials}
                        </Avatar>
                        <div className="min-w-0 flex-1">
                            <h3 className="font-semibold text-sm sm:text-base mb-1 truncate" title={record.userEmail}>
                                {record.userEmail || "N/A"}
                            </h3>
                            <div className="flex items-center text-xs sm:text-sm text-gray-500">
                                <MailOutlined className="mr-1 flex-shrink-0" />
                                <span className="truncate" title={record.emailTo}>
                                    To: {record.emailTo}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Body */}
                <div className="space-y-2">
                    <div className="flex items-center justify-between text-xs sm:text-sm text-gray-600">
                        <span className="font-medium">Sent At:</span>
                        <span>{formatDateTime(record.createdAt)}</span>
                    </div>
                    {/* Message Preview */}
                    <div className="mt-2">
                        <span className="font-medium text-xs sm:text-sm text-gray-600 block mb-1">Message Preview:</span>
                        <div
                            className="text-xs sm:text-sm text-gray-500 line-clamp-1"
                            dangerouslySetInnerHTML={{ __html: record.emailBody }}
                        />
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default EnhancedEmailLogCardView;
